module.exports = __webpack_public_path__ + "img/slider_dot.56406a1b.svg";